import { AccessTimeRounded } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { NavLinkComponent } from '../../Router';
import NavLink from '../../components/NavLink';
import { DataListComponent } from '../../components/data/DataTable';
import { EntryPass } from '../../models/Types';

const styles = {
    mobileIconWrapper: {
        p: .66,
        display: 'flex',
        borderRadius: .5
    },
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildEntryPassListItem(x: EntryPass) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['page', 'entrypass'], ['id', x.Id]]}>
        <Box display="flex" flexDirection="column" minWidth={80} gap={.5}>
            <NavLink variant="h3">{x.Name || x.CarModel || '-'}</NavLink>
            <Typography variant="body4">{x.Expire ? moment(new Date(x.Expire)).calendar() : 'Бессрочный'}</Typography>
        </Box>
        <Typography variant="h3" textAlign="left" flex={1}>{x.Color}</Typography>
        <Typography variant="h3" textAlign="left">{x.CarNumber}</Typography>
    </Paper>;
}

export default class EntryPassList extends DataListComponent<EntryPass> {
    buildItemPaper(x: EntryPass, i: number) {
        return buildEntryPassListItem(x);
    }
}